import { Controller } from "@hotwired/stimulus"
import Swiper from "swiper"

export default class extends Controller {
    static targets = ["step"]

    connect() {
        this.handleResize = this.handleResize.bind(this)
        this.handleResize() // init once with correct mode
        window.addEventListener("resize", this.handleResize)
    }

    disconnect() {
        this._destroySwiper()
        window.removeEventListener("resize", this.handleResize)
    }

    handleResize() {
        const mobile = window.innerWidth <= 1280
        if (mobile && !this.swiper) {
            this._initSwiper()
        } else if (!mobile && this.swiper) {
            this._destroySwiper()
        } else if (this.swiper) {
            this.swiper.update()
            this._centerActive() // keep centered on orientation changes, etc.
        }
    }

    _initSwiper() {
        const initial = this.stepTargets.findIndex(el => el.classList.contains("active"))
        this.swiper = new Swiper(this.element, {
            slidesPerView: 5,
            spaceBetween: 12,
            initialSlide: Math.max(0, initial),
            // mobile-only centering via breakpoints
            breakpoints: {
                0: {
                    slidesPerView: 2.5,
                    spaceBetween: 8,
                    slidesOffsetAfter: 30,
                    centeredSlides: true,         // center on phones
                    centeredSlidesBounds: true
                },
                414: {
                    slidesPerView: 2.6,
                    spaceBetween: 12,
                    slidesOffsetAfter: 40,
                    centeredSlides: true,         // keep centered
                    centeredSlidesBounds: true
                },
                768: {
                    slidesPerView: 4,
                    spaceBetween: 5,
                    slidesOffsetAfter: 0,
                    centeredSlides: false         // stop centering on tablets/desktop
                }
            }
        })
        // Swiper sometimes needs an explicit nudge on first paint
        this._centerActive()
    }

    _destroySwiper() {
        if (!this.swiper) return
        this.swiper.destroy(true, true)
        this.swiper = null
    }

    _centerActive() {
        if (!this.swiper) return
        const idx = this.stepTargets.findIndex(el => el.classList.contains("active"))
        if (idx >= 0) this.swiper.slideTo(idx, 0) // no animation
    }

    selectStep(event) {
        this.stepTargets.forEach(step => step.classList.remove("active"))
        event.currentTarget.classList.add("active")
        if (this.swiper) this._centerActive() // center on mobile
    }
}